import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'

/**
 * Displays how long a sensor is licenced for.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmLicencedUntil = (classes, props = {}) => {
  const { licensedUntil = '-' } = props

  return (
    <Text
      color={'black'}
      variant={'14/medium'}
      className={classes.row}
    >
      {licensedUntil}
    </Text>
  )
}

export default CellHOC(ListItemCellXEcoApmLicencedUntil)
